<div class="art-page">

  <!-- ── Progress bar ──────────────────────────────── -->
  <div class="car-progress-bar" *ngIf="!enregistrementTerminer">
    <div class="car-progress-bar__inner"></div>
  </div>

  <!-- ── Page header ──────────────────────────────── -->
  <header class="car-page__header">
    <div class="art-page__header-left">
      <h1 class="car-page__title">
        <span class="car-page__title-icon">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
            <rect x="2" y="3" width="20" height="14" rx="2" />
            <path d="M8 21h8M12 17v4" />
          </svg>
        </span>
        Article
      </h1>
      <p class="car-page__subtitle">Gérer les informations, familles, détails, images et documents de vos articles.</p>
    </div>

    <!-- Excel export buttons (SNCT only) -->
    <div class="art-export-btns" *ngIf="generalService.cuurentUser == 'SNCT'">
      <button type="button" class="art-export-btn" (click)="generateExcel()" title="Liste Article">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
          <polyline points="14 2 14 8 20 8" />
          <line x1="8" y1="13" x2="16" y2="13" />
          <line x1="8" y1="17" x2="16" y2="17" />
        </svg>
        <span>Liste Article</span>
      </button>
      <button type="button" class="art-export-btn" (click)="generateExcelCat()" title="Liste Catégories">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
          <polyline points="14 2 14 8 20 8" />
          <line x1="8" y1="13" x2="16" y2="13" />
          <line x1="8" y1="17" x2="16" y2="17" />
        </svg>
        <span>Liste Catégories</span>
      </button>
    </div>
  </header>

  <form #f="ngForm">

    <!-- ── Tab bar ─────────────────────────────────── -->
    <div class="art-tabs">
      <button type="button" class="art-tab" [class.active]="index === 0" (click)="index = 0; tabChanged()">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
          <circle cx="12" cy="8" r="5" />
          <path d="M3 21v-2a7 7 0 0 1 14 0v2" />
        </svg>
        Information article
      </button>
      <button type="button" class="art-tab" [class.active]="index === 1" [disabled]="activerFamilleArticle"
        (click)="index = 1; tabChanged()">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
          <path d="M3 3h7v7H3zM14 3h7v7h-7zM3 14h7v7H3zM14 14h7v7h-7z" />
        </svg>
        Famille article
      </button>
      <button type="button" class="art-tab" [class.active]="index === 2" [disabled]="activerDetailsArticle"
        (click)="index = 2; tabChanged()">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
          <line x1="8" y1="6" x2="21" y2="6" />
          <line x1="8" y1="12" x2="21" y2="12" />
          <line x1="8" y1="18" x2="21" y2="18" />
          <line x1="3" y1="6" x2="3.01" y2="6" />
          <line x1="3" y1="12" x2="3.01" y2="12" />
          <line x1="3" y1="18" x2="3.01" y2="18" />
        </svg>
        Détails article
      </button>
      <button type="button" class="art-tab" [class.active]="index === 3" [disabled]="activerImagesArticle"
        (click)="index = 3; tabChanged()">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
          <rect x="3" y="3" width="18" height="18" rx="2" />
          <circle cx="8.5" cy="8.5" r="1.5" />
          <polyline points="21 15 16 10 5 21" />
        </svg>
        Images article
      </button>
      <button type="button" class="art-tab" [class.active]="index === 4" [disabled]="activerProduit"
        (click)="index = 4; tabChanged()">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
          <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" />
          <line x1="7" y1="7" x2="7.01" y2="7" />
        </svg>
        Produits complémentaires
      </button>
      <button type="button" class="art-tab" [class.active]="index === 5" [disabled]="activerProduit"
        (click)="index = 5; tabChanged()">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
          <circle cx="18" cy="18" r="3" />
          <circle cx="6" cy="6" r="3" />
          <path d="M13 6h3a2 2 0 0 1 2 2v7M11 18H8a2 2 0 0 1-2-2V9" />
        </svg>
        Produits similaires
      </button>
      <button type="button" class="art-tab" [class.active]="index === 6" [disabled]="activerProduit"
        (click)="index = 6; tabChanged()">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
          <polyline points="14 2 14 8 20 8" />
        </svg>
        PDF article
      </button>
    </div>

    <!-- ══════════════════════════════════════════════
         TAB 0 — Information article
    ══════════════════════════════════════════════ -->
    <div class="art-tab-panel" [class.active]="index === 0">

      <!-- Main info grid -->
      <div class="art-info-grid">

        <!-- LEFT — Identité -->
        <section class="car-panel">
          <div class="car-panel__header">
            <div class="car-panel__header-left">
              <span class="car-panel__icon">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
                  <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                  <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                </svg>
              </span>
              Identité
            </div>
          </div>
          <div class="car-panel__body">
            <div class="car-form-row">
              <div class="car-field" style="width: 120px; flex-shrink: 0;">
                <label class="car-label">Code article</label>
                <input class="car-input" [disabled]="typeTrs != '1'" name="Art_Code" #Art_Code="ngModel"
                  (input)="removeSpecialCarater()" [(ngModel)]="article.Art_Code" placeholder="Code" required />
              </div>
              <div class="car-field car-field--grow">
                <label class="car-label">Désignation article</label>
                <input class="car-input" [disabled]="disabled" name="Art_Des" #Art_Des="ngModel"
                  [(ngModel)]="article.Art_Des" placeholder="Désignation article" required />
              </div>
            </div>
            <div class="car-form-row">
              <div class="car-field car-field--grow">
                <label class="car-label">Désignation français</label>
                <input class="car-input" [disabled]="disabled" name="Art_Defs4" [(ngModel)]="text[0][0]"
                  placeholder="Désignation article français" />
              </div>
              <div class="car-field car-field--grow">
                <label class="car-label">Désignation anglais</label>
                <input class="car-input" [disabled]="disabled" name="ArtDesAnglais" [(ngModel)]="text[1][0]"
                  placeholder="Désignation article anglais" />
              </div>
            </div>
            <div class="car-field">
              <label class="car-label">Commentaire</label>
              <textarea class="car-textarea" [(ngModel)]="article.Art_Commentaire" name="Art_Commentaire"
                placeholder="Commentaire…" rows="3"></textarea>
            </div>
          </div>
        </section>

        <!-- RIGHT — Pricing & props -->
        <section class="car-panel">
          <div class="car-panel__header">
            <div class="car-panel__header-left">
              <span class="car-panel__icon">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
                  <line x1="12" y1="1" x2="12" y2="23" />
                  <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
                </svg>
              </span>
              Tarification &amp; Propriétés
            </div>
          </div>
          <div class="car-panel__body">
            <div class="car-form-row" style="flex-wrap: wrap;">
              <div class="car-field" style="width: 88px; flex-shrink: 0;">
                <label class="car-label">Prix</label>
                <input class="car-input" [disabled]="disabled" name="Art_PV" type="number" [(ngModel)]="article.Art_PV"
                  placeholder="0.00" required />
              </div>
              <div class="car-field" style="width: 88px; flex-shrink: 0;">
                <label class="car-label">Ancien prix</label>
                <input class="car-input" [disabled]="disabled" name="Art_PV1" type="number"
                  [(ngModel)]="article.Art_PV1" placeholder="0.00" />
              </div>
              <div class="car-field" style="width: 110px; flex-shrink: 0;">
                <label class="car-label">État</label>
                <select class="car-select" name="etat" [(ngModel)]="article.Art_Status" required>
                  <option value="1">Active</option>
                  <option value="0">Inactive</option>
                </select>
              </div>
              <div class="car-field" style="width: 130px; flex-shrink: 0;">
                <label class="car-label">Durée garantie</label>
                <input class="car-input" [disabled]="disabled" name="Art_Garantie" [(ngModel)]="article.Art_Garantie"
                  placeholder="ex: 12 mois" />
              </div>
              <div class="car-field" style="width: 88px; flex-shrink: 0;">
                <label class="car-label">Poids</label>
                <input class="car-input" [disabled]="disabled" name="Art_Poids" type="number"
                  [(ngModel)]="article.Art_Poids" placeholder="kg" required />
              </div>
              <div class="car-field" style="width: 110px; flex-shrink: 0;">
                <label class="car-label">Promo</label>
                <select class="car-select" name="promo" [(ngModel)]="article.Art_Stat5" required>
                  <option value="1">Active</option>
                  <option value="0">Inactive</option>
                </select>
              </div>
              <div class="car-field" style="width: 110px; flex-shrink: 0;" *ngIf="generalService.cuurentUser == 'SNCT'">
                <label class="car-label">SiteWeb</label>
                <input class="car-input" [disabled]="disabled" name="SiteWeb" [(ngModel)]="article.Art_Stat4"
                  placeholder="SiteWeb" />
              </div>
            </div>

            <div class="car-form-row">
              <div class="car-field car-field--grow">
                <label class="car-label">{{ generalService.cuurentUser == 'BIGDAR' ? 'Référence internationale' :
                  'Unité' }}</label>
                <input class="car-input" [disabled]="disabled" name="Art_CodeCpt" [(ngModel)]="article.Art_CodeCpt"
                  placeholder="{{ generalService.cuurentUser == 'BIGDAR' ? 'Référence internationale' : 'Unité' }}" />
              </div>
              <div class="car-field" style="width: 88px; flex-shrink: 0;">
                <label class="car-label">Livraison</label>
                <input class="car-input" [disabled]="disabled" type="number" name="Art_DL" [(ngModel)]="article.Art_DL"
                  placeholder="0" />
              </div>
            </div>

            <!-- Marque upload (BIGDAR) -->
            <div *ngIf="generalService.cuurentUser == 'BIGDAR'" class="art-marque-row">
              <div class="grp-img-upload">
                <div class="grp-img-upload__preview" style="width: 64px; height: 64px;"
                  (click)="importerMarque('input_Marque')">
                  <img id="30_30"
                    [src]="lastEvent == 'upload' ? imageMarqueSrc : generalService.base_url + 'images/' + article.Art_Marque"
                    alt="Marque" />
                  <div class="grp-img-upload__overlay">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
                      <circle cx="12" cy="13" r="4" />
                    </svg>
                  </div>
                </div>
                <input id="input_Marque" type="file" style="display:none" (change)="onChangeImageMarque($event)" />
              </div>
              <button type="button" (click)="SupprimerMarque()" [disabled]="disabled"
                class="car-btn car-btn--danger car-btn--sm">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
                Supprimer Marque
              </button>
            </div>

            <!-- Pertinence (SNCT) -->
            <div class="car-field" style="width: 130px;" *ngIf="generalService.cuurentUser == 'SNCT'">
              <label class="car-label">Pertinence</label>
              <select class="car-select" name="Pertinence" [(ngModel)]="article.Art_Variante1" required>
                <option value="1">Oui</option>
                <option value="0">Non</option>
              </select>
            </div>

            <!-- Stock radio group -->
            <div class="art-stock-group">
              <label class="car-label">État stock</label>
              <div class="art-radio-group">
                <label *ngFor="let etat of typeEtatStock" class="art-radio-label">
                  <input type="radio" name="Art_Stock" [(ngModel)]="article.Art_Stock" [value]="etat.value" />
                  <span class="art-radio-track"></span>
                  {{ etat.text }}
                </label>
              </div>
            </div>
          </div>
        </section>
      </div>

      <!-- ── Accordion: descriptions ─────────────── -->
      <div class="art-accordion">

        <!-- Panel: Bref + Tableau -->
        <div class="art-acc-item" [class.open]="accOpen[0]">
          <button type="button" class="art-acc-header" (click)="accOpen[0] = !accOpen[0]">
            <span class="art-acc-header__title">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <polyline points="14 2 14 8 20 8" />
                <line x1="8" y1="13" x2="16" y2="13" />
                <line x1="8" y1="17" x2="16" y2="17" />
              </svg>
              Tableau de description / Bref description
            </span>
            <svg class="art-acc-chevron" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              stroke-width="2.5">
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </button>
          <div class="art-acc-body">
            <div class="art-editors-grid">
              <div class="art-editor-wrap">
                <p class="art-editor-label">Bref description</p>
                <quill-editor class="brief-editor" #quillEditorRef [(ngModel)]="article.Art_Des1" format="html"
                  [modules]="quillModules" theme="snow" (onContentChanged)="logValue(article.Art_Des1)"
                  style="height: 400px" name="brief_desc">
                </quill-editor>
              </div>
              <div class="art-editor-wrap">
                <p class="art-editor-label">Tableau de description</p>
                <ckeditor
                  [config]="{toolbar:{items:['heading','|','alignment','bold','italic','link','bulletedList','numberedList','blockQuote','undo','redo']}}"
                  [editor]="Editor" name="Art_Des3" [(ngModel)]="article.Art_Des3" #Art_Des1j="ngModel"
                  style="height: 300px">
                </ckeditor>
              </div>
            </div>
          </div>
        </div>

        <!-- Panels: Descriptions détaillées 1-5 -->
        <div *ngFor="let descIdx of [1,2,3,4,5]; let di = index" class="art-acc-item" [class.open]="accOpen[di + 1]">
          <button type="button" class="art-acc-header" (click)="accOpen[di + 1] = !accOpen[di + 1]">
            <span class="art-acc-header__title">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <line x1="8" y1="6" x2="21" y2="6" />
                <line x1="8" y1="12" x2="21" y2="12" />
                <line x1="8" y1="18" x2="21" y2="18" />
              </svg>
              Description détaillée {{ descIdx }}
            </span>
            <svg class="art-acc-chevron" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              stroke-width="2.5">
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </button>
          <div class="art-acc-body">
            <div class="art-editors-grid art-editors-grid--two">
              <div class="art-editor-wrap">
                <p class="art-editor-label">Français</p>
                <quill-editor [modules]="quillModules" [name]="'descFr' + descIdx" placeholder="Fr"
                  [(ngModel)]="descIdx === 1 ? article.Art_Des2 : text[0][descIdx + 1]">
                </quill-editor>
              </div>
              <div class="art-editor-wrap">
                <p class="art-editor-label">Anglais</p>
                <quill-editor [modules]="quillModules" [name]="'descEn' + descIdx" placeholder="En"
                  [(ngModel)]="text[1][descIdx + 1]">
                </quill-editor>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- ══════════════════════════════════════════════
         TAB 1 — Famille article
    ══════════════════════════════════════════════ -->
    <div class="art-tab-panel" [class.active]="index === 1">
      <section class="car-panel">
        <div class="car-panel__header">
          <div class="car-panel__header-left">
            <span class="car-panel__icon">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
                <path d="M3 3h7v7H3zM14 3h7v7h-7zM3 14h7v7H3zM14 14h7v7h-7z" />
              </svg>
            </span>
            Famille article
          </div>
          <div class="car-panel__header-actions">
            <button type="button" (click)="add()" class="car-btn car-btn--primary car-btn--sm">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8">
                <line x1="12" y1="5" x2="12" y2="19" />
                <line x1="5" y1="12" x2="19" y2="12" />
              </svg>
              Ajouter
            </button>
          </div>
        </div>
        <div class="car-panel__body">
          <div *ngFor="let item of ListCat; let j = index" class="art-famille-row">
            <div class="car-field car-field--grow">
              <label class="car-label">Catégorie</label>
              <input class="car-input" (input)="onCategoriesNiveau1Valuechange($event, j)" [disabled]="disabled"
                [matAutocomplete]="autoo" [name]="j + 'categoriesNiv1'" #categoriesNiv1="ngModel"
                [(ngModel)]="catNiv1[j]" placeholder="Catégorie" required />
              <mat-autocomplete #autoo="matAutocomplete" (optionSelected)="categoriesNiveau1Selected($event, j)">
                <mat-option *ngFor="let c of categoriesNiveau1[j]" [id]="j + c.categorie_Code"
                  [value]="c.categorie_Text">
                  {{ c.categorie_Text }}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="car-field car-field--grow">
              <label class="car-label">Famille</label>
              <input class="car-input" [disabled]="disabled" [id]="j + 'idCategoriesNiveau2'"
                [name]="j + 'categoriesNiveau2'" [matAutocomplete]="autoCategoriesNiveau2" [(ngModel)]="catNiv2[j]"
                (input)="onCategoriesNiveau2Valuechange($event, j, false)" placeholder="Famille" />
              <mat-autocomplete #autoCategoriesNiveau2="matAutocomplete"
                (optionSelected)="categoriesNiveau2Selected($event, j, false)">
                <mat-option *ngFor="let option of categoriesNiveau2[j]" [id]="j + option.categorie_Code"
                  [value]="option.categorie_Text">{{ option.categorie_Text }}</mat-option>
              </mat-autocomplete>
            </div>
            <div class="car-field car-field--grow">
              <label class="car-label">Sous famille</label>
              <input class="car-input" [disabled]="disabled" [id]="j + 'idCategoriesNiveau3'"
                [name]="j + 'categoriesNiveau3'" [matAutocomplete]="autoCategoriesNiveau3" [(ngModel)]="catNiv3[j]"
                (input)="onCategoriesNiveau3Valuechange($event, j, false)" placeholder="Sous famille" />
              <mat-autocomplete #autoCategoriesNiveau3="matAutocomplete"
                (optionSelected)="categoriesNiveau3Selected($event, j, false)">
                <mat-option *ngFor="let option of categoriesNiveau3[j]" [id]="option.categorie_Code"
                  [value]="option.categorie_Text">{{ option.categorie_Text }}</mat-option>
              </mat-autocomplete>
            </div>
            <div class="art-famille-actions">
              <button type="button" class="grp-icon-btn" style="color: var(--success);" title="Enregistrer"
                (click)="update(j)">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
                  <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
                  <polyline points="17 21 17 13 7 13 7 21" />
                  <polyline points="7 3 7 8 15 8" />
                </svg>
              </button>
              <button type="button" class="grp-icon-btn grp-icon-btn--rose" title="Supprimer" (click)="deleteCat(j)">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              </button>
            </div>
          </div>

          <div class="art-sub-section-title">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="8" y1="6" x2="21" y2="6" />
              <line x1="8" y1="12" x2="21" y2="12" />
              <line x1="8" y1="18" x2="21" y2="18" />
            </svg>
            Liste articles enfants
          </div>
          <app-liste #listeComponen [showFilter]="false" [heightTable]="'400'" [displayedColumnsBrut]="columns">
          </app-liste>
        </div>
      </section>
    </div>

    <!-- ══════════════════════════════════════════════
         TAB 2 — Détails article
    ══════════════════════════════════════════════ -->
    <div class="art-tab-panel" [class.active]="index === 2">
      <section class="car-panel">
        <div class="car-panel__header">
          <div class="car-panel__header-left">
            <span class="car-panel__icon">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
                <line x1="8" y1="6" x2="21" y2="6" />
                <line x1="8" y1="12" x2="21" y2="12" />
                <line x1="8" y1="18" x2="21" y2="18" />
              </svg>
            </span>
            Détails article
          </div>
          <div class="car-panel__header-actions">
            <button type="button" (click)="enregistrerCaracteristique()" class="car-btn car-btn--success car-btn--sm">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
                <polyline points="17 21 17 13 7 13 7 21" />
              </svg>
              Enregistrer détails
            </button>
            <button *ngIf="typeTrs == '2'" type="button" (click)="supprimerDetailArticle()"
              class="car-btn car-btn--danger car-btn--sm">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="3 6 5 6 21 6" />
                <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
              </svg>
              Supprimer
            </button>
          </div>
        </div>
        <div class="car-panel__body">
          <!-- Model autocomplete -->
          <div class="car-field" style="max-width: 320px;">
            <label class="car-label">Modèle</label>
            <input class="car-input" [disabled]="disabled" (input)="onCaracteristiqueModelValuechange($event)"
              placeholder="Modèle" [matAutocomplete]="caracteristiqueModel" name="caracteristique_Model"
              #caracteristique_Model="ngModel" [(ngModel)]="modelCaracteristiqueArticle.ecArtCarMod_Label" />
            <mat-autocomplete #caracteristiqueModel="matAutocomplete"
              (optionSelected)="caracteristiqueModelSelected($event)">
              <mat-option *ngFor="let option of listeModel" [id]="option.ecArtCarMod_Id"
                [value]="option.ecArtCarMod_Label">{{ option.ecArtCarMod_Label }}</mat-option>
            </mat-autocomplete>
          </div>

          <!-- Filter -->
          <div class="car-toolbar">
            <div class="car-search">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="11" cy="11" r="8" />
                <line x1="21" y1="21" x2="16.65" y2="16.65" />
              </svg>
              <input class="car-search__input" type="text" (keyup)="applyFilter($event.target.value)"
                placeholder="Filtrer…" />
            </div>
          </div>

          <div class="car-table-wrap">
            <table class="car-table">
              <thead>
                <tr>
                  <th style="width: 80px;">Code</th>
                  <th>Texte</th>
                  <th>Valeur</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let element of dataSourceCaracteristique.data ?? dataSourceCaracteristique"
                  (click)="selectRow($event, element, 'caracteristique')">
                  <td class="code">{{ element.ecArtCar_Id }}</td>
                  <td class="bold">{{ element.ecArtCar_Label }}</td>
                  <td>
                    {{ element.ecArtCar_Val }}&nbsp;
                    <button type="button" class="grp-icon-btn" style="color: var(--acc);" title="Rechercher valeur"
                      (click)="getValeurCaracteristique(element)">
                      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2">
                        <circle cx="11" cy="11" r="8" />
                        <line x1="21" y1="21" x2="16.65" y2="16.65" />
                      </svg>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </div>

    <!-- ══════════════════════════════════════════════
         TAB 3 — Images article
    ══════════════════════════════════════════════ -->
    <div class="art-tab-panel" [class.active]="index === 3">
      <section class="car-panel">
        <div class="car-panel__header">
          <div class="car-panel__header-left">
            <span class="car-panel__icon">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
                <rect x="3" y="3" width="18" height="18" rx="2" />
                <circle cx="8.5" cy="8.5" r="1.5" />
                <polyline points="21 15 16 10 5 21" />
              </svg>
            </span>
            Images rectangulaires
          </div>
        </div>
        <div class="car-panel__body">
          <div *ngFor="let color1 of listeColor1" class="art-color-block">
            <div class="art-color-block__header">
              <b *ngIf="color1.color != '-1'" class="art-color-badge">Couleur : {{ color1.ArtV_Code1 }}</b>
              <div class="art-color-block__actions">
                <button type="button" class="car-btn car-btn--primary car-btn--sm" [disabled]="!enregistrementTerminer"
                  (click)="openFrmImage('ajouter', 'rectengle', color1.color)">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="16 16 12 12 8 16" />
                    <line x1="12" y1="12" x2="12" y2="21" />
                    <path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3" />
                  </svg>
                  Upload
                </button>
                <button type="button" class="car-btn car-btn--danger car-btn--sm" [disabled]="!enregistrementTerminer"
                  (click)="supprimerImages('rectengle', color1.color)">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="3 6 5 6 21 6" />
                    <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
                  </svg>
                  Supprimer
                </button>
              </div>
            </div>
            <div class="art-img-grid">
              <div *ngFor="let img of filterImageByColor(listeImgRectengle, color1.color); let i = index"
                class="art-img-card" (click)="selectionnerImage(img, 'rectengle', color1.ArtV_Code1, i)">
                <img #imagePrincipale
                  [src]="(useDataBaseToSaveImage == 1 ? '' : base_url + 'images/') + img.File_Content"
                  [id]="'rectengle' + color1.ArtV_Code1 + i" class="art-img-card__img" />
                <div class="art-img-card__footer">
                  <select *ngIf="listeColor.length > 0" class="car-select car-select--sm" [name]="'etat' + img.File_Id"
                    [(ngModel)]="img.File_Dll">
                    <option *ngFor="let color of listeColor" [value]="color.color">{{ color.ArtV_Code1 }}</option>
                  </select>
                  <div class="art-img-order">
                    <button type="button" class="art-order-btn" (click)="setOrder(1, img)">
                      <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2.5">
                        <line x1="12" y1="5" x2="12" y2="19" />
                        <line x1="5" y1="12" x2="19" y2="12" />
                      </svg>
                    </button>
                    <span class="art-order-val">{{ img.File_Class }}</span>
                    <button type="button" class="art-order-btn art-order-btn--minus" (click)="setOrder(-1, img)">
                      <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2.5">
                        <line x1="5" y1="12" x2="19" y2="12" />
                      </svg>
                    </button>
                  </div>
                  <button type="button" class="car-btn car-btn--success car-btn--sm"
                    [disabled]="!enregistrementTerminer" (click)="modifierOrderImages(img, 'rectengle')">
                    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
                    </svg>
                  </button>
                  <label class="car-toggle car-toggle--sm">
                    <input type="checkbox" [name]="'check' + i" [(ngModel)]="checked[i]"
                      (change)="onselectionChange($event, i, img)" />
                    <span class="car-toggle__track"></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <input id="input_file99" type="file" style="display:none" (change)="onChangeImagefile($event)" />
        </div>
      </section>
    </div>

    <!-- ══════════════════════════════════════════════
         TAB 4 — Produits complémentaires
    ══════════════════════════════════════════════ -->
    <!-- TAB 4 — Produits complémentaires -->
    <div class="art-tab-panel" [class.active]="index === 4">
      <section class="car-panel">
        <div class="car-panel__header">
          <div class="car-panel__header-left">
            <span class="car-panel__icon">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
                <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" />
                <line x1="7" y1="7" x2="7.01" y2="7" />
              </svg>
            </span>
            Produits complémentaires
          </div>
          <div class="car-panel__header-actions">
            <button type="button" (click)="ajouterProduit('1')" [disabled]="disabled"
              class="car-btn car-btn--primary car-btn--sm">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8">
                <line x1="12" y1="5" x2="12" y2="19" />
                <line x1="5" y1="12" x2="19" y2="12" />
              </svg>
              Ajouter
            </button>
            <button type="button" (click)="supprimerProduitComplementaire()" [disabled]="disabled"
              class="car-btn car-btn--danger car-btn--sm">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="3 6 5 6 21 6" />
                <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
              </svg>
              Supprimer
            </button>
          </div>
        </div>
        <div class="car-panel__body">
          <div class="car-form-row">
            <div class="car-field car-field--grow">
              <app-recherche recherche="ecarticleauto2" displayColumn="Art_Des" name="articleComplementaire"
                (clickClearText)="ClearTextComplementaire()" [(ngModel)]="artComplementaire"
                placeholder="Rechercher un article…">
              </app-recherche>
            </div>
          </div>
          <div class="car-toolbar">
            <div class="car-search">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="11" cy="11" r="8" />
                <line x1="21" y1="21" x2="16.65" y2="16.65" />
              </svg>
              <input class="car-search__input" type="text" (keyup)="applyFilter($event.target.value)"
                placeholder="Filtrer…" />
            </div>
          </div>
          <div class="car-table-wrap">
            <table class="car-table">
              <thead>
                <tr>
                  <th style="width: 100px;">Code</th>
                  <th>Désignation</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let element of dataSourceProduitsComplementaire.data ?? dataSourceProduitsComplementaire"
                  (click)="selectRow($event, element, 'complementaire')">
                  <td class="code">{{ element.Art_Code }}</td>
                  <td class="bold">{{ element.Art_Des }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </div>

    <!-- ══════════════════════════════════════════════
         TAB 5 — Produits similaires
    ══════════════════════════════════════════════ -->
    <div class="art-tab-panel" [class.active]="index === 5">
      <section class="car-panel">
        <div class="car-panel__header">
          <div class="car-panel__header-left">
            <span class="car-panel__icon">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
                <circle cx="18" cy="18" r="3" />
                <circle cx="6" cy="6" r="3" />
                <path d="M13 6h3a2 2 0 0 1 2 2v7M11 18H8a2 2 0 0 1-2-2V9" />
              </svg>
            </span>
            Produits similaires
          </div>
          <div class="car-panel__header-actions">
            <button type="button" (click)="ajouterProduit('2')" [disabled]="disabled"
              class="car-btn car-btn--primary car-btn--sm">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8">
                <line x1="12" y1="5" x2="12" y2="19" />
                <line x1="5" y1="12" x2="19" y2="12" />
              </svg>
              Ajouter
            </button>
            <button type="button" (click)="supprimerProduitSimilaires()" [disabled]="disabled"
              class="car-btn car-btn--danger car-btn--sm">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="3 6 5 6 21 6" />
                <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
              </svg>
              Supprimer
            </button>
          </div>
        </div>
        <div class="car-panel__body">
          <div class="car-form-row">
            <div class="car-field car-field--grow">
              <app-recherche recherche="ecarticleauto2" displayColumn="Art_Des" name="articleSimilaires"
                (clickClearText)="ClearTextSimilaires()" [(ngModel)]="artSimilaires"
                placeholder="Rechercher un article…">
              </app-recherche>
            </div>
          </div>
          <div class="car-toolbar">
            <div class="car-search">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="11" cy="11" r="8" />
                <line x1="21" y1="21" x2="16.65" y2="16.65" />
              </svg>
              <input class="car-search__input" type="text" (keyup)="applyFilter($event.target.value)"
                placeholder="Filtrer…" />
            </div>
          </div>
          <div class="car-table-wrap">
            <table class="car-table">
              <thead>
                <tr>
                  <th style="width: 100px;">Code</th>
                  <th>Désignation</th>
                </tr>
              </thead>
              <tbody class="">
                <tr *ngFor="let element of dataSourceProduitsSimilaires.data ?? dataSourceProduitsSimilaires"
                  (click)="selectRow($event, element, 'similaires')">
                  <td class="code">{{ element.Art_Code }}</td>
                  <td class="bold">{{ element.Art_Des }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </div>

    <!-- ══════════════════════════════════════════════
         TAB 6 — PDF article
    ══════════════════════════════════════════════ -->
    <div class="art-tab-panel" [class.active]="index === 6">
      <section class="car-panel">
        <div class="car-panel__header">
          <div class="car-panel__header-left">
            <span class="car-panel__icon">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <polyline points="14 2 14 8 20 8" />
              </svg>
            </span>
            PDF article
          </div>
          <div class="car-panel__header-actions">
            <button type="button" class="car-btn car-btn--primary car-btn--sm" [disabled]="!enregistrementTerminerPDF"
              (click)="openFrmPdf('ajouter')">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="16 16 12 12 8 16" />
                <line x1="12" y1="12" x2="12" y2="21" />
                <path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3" />
              </svg>
              Upload
            </button>
            <button type="button" class="car-btn car-btn--slate car-btn--sm" [disabled]="!enregistrementTerminerPDF"
              (click)="openFrmPdf('modifier')">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
              </svg>
              Modifier
            </button>
            <button type="button" class="car-btn car-btn--danger car-btn--sm" [disabled]="!enregistrementTerminerPDF"
              (click)="supprimerPdf()">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="3 6 5 6 21 6" />
                <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
              </svg>
              Supprimer
            </button>
          </div>
        </div>
        <div class="car-panel__body">
          <div *ngIf="article.Art_pdf" class="art-pdf-preview" (click)="getSelectedFile(article.Art_pdf)">
            <div class="art-pdf-icon">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <polyline points="14 2 14 8 20 8" />
                <line x1="9" y1="13" x2="15" y2="13" />
                <line x1="9" y1="17" x2="15" y2="17" />
              </svg>
            </div>
            <span class="art-pdf-name">{{ article.Art_pdf }}</span>
            <span class="art-pdf-hint">Cliquer pour prévisualiser</span>
          </div>
          <div *ngIf="showPdf" class="art-pdf-viewer" id="pdf"></div>
        </div>
      </section>
      <input id="input_file" type="file" style="display:none" (change)="onChangeImagefile2($event)" />
    </div>

    <!-- ── Footer actions ─────────────────────────── -->
    <div class="art-footer">
      <button type="button" (click)="suivant(f)" class="car-btn car-btn--primary">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
          <line x1="5" y1="12" x2="19" y2="12" />
          <polyline points="12 5 19 12 12 19" />
        </svg>
        Étape suivante
      </button>
      <button *ngIf="showBtn" type="button" [disabled]="disabled" (click)="enregistrer(f)"
        class="car-btn car-btn--success">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
          <polyline points="17 21 17 13 7 13 7 21" />
          <polyline points="7 3 7 8 15 8" />
        </svg>
        Enregistrer article
      </button>
    </div>

  </form>

  <!-- Produits complémentaires inline (tab 4) -->
  <ng-template #produitCompPanel>
    <section class="car-panel">
      <div class="car-panel__header">
        <div class="car-panel__header-left">
          <span class="car-panel__icon">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
              <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" />
              <line x1="7" y1="7" x2="7.01" y2="7" />
            </svg>
          </span>
          Produits complémentaires
        </div>
        <div class="car-panel__header-actions">
          <button type="button" (click)="ajouterProduit('1')" [disabled]="disabled"
            class="car-btn car-btn--primary car-btn--sm">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8">
              <line x1="12" y1="5" x2="12" y2="19" />
              <line x1="5" y1="12" x2="19" y2="12" />
            </svg>
            Ajouter
          </button>
          <button type="button" (click)="supprimerProduitComplementaire()" [disabled]="disabled"
            class="car-btn car-btn--danger car-btn--sm">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="3 6 5 6 21 6" />
              <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
            </svg>
            Supprimer
          </button>
        </div>
      </div>
      <div class="car-panel__body">
        <div class="car-form-row">
          <div class="car-field car-field--grow">
            <app-recherche recherche="ecarticleauto2" displayColumn="Art_Des" name="articleComplementaire"
              (clickClearText)="ClearTextComplementaire()" [(ngModel)]="artComplementaire"
              placeholder="Rechercher un article…">
            </app-recherche>
          </div>
        </div>
        <div class="car-toolbar">
          <div class="car-search">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="11" cy="11" r="8" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>
            <input class="car-search__input" type="text" (keyup)="applyFilter($event.target.value)"
              placeholder="Filtrer…" />
          </div>
        </div>
        <div class="car-table-wrap">
          <table class="car-table">
            <thead>
              <tr>
                <th style="width: 100px;">Code</th>
                <th>Désignation</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let element of dataSourceProduitsComplementaire.data ?? dataSourceProduitsComplementaire"
                (click)="selectRow($event, element, 'complementaire')">
                <td class="code">{{ element.Art_Code }}</td>
                <td class="bold">{{ element.Art_Des }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  </ng-template>

</div>

<!-- ══════════════════════════════════════════════
     Dialog: famille article
══════════════════════════════════════════════ -->
<ng-template #dialogue>
  <div class="art-dialog">
    <div class="art-dialog__header">
      <span class="art-dialog__title">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
          <path d="M3 3h7v7H3zM14 3h7v7h-7zM3 14h7v7H3zM14 14h7v7h-7z" />
        </svg>
        Ajouter famille
      </span>
    </div>
    <div class="art-dialog__body">
      <div class="car-field">
        <label class="car-label">Catégorie</label>
        <input class="car-input" (input)="onCategoriesNiveau1Valuechange1($event)" [disabled]="disabled"
          placeholder="Catégorie" [matAutocomplete]="autoo1" name="categoriesNiv1v1" #categorieNiv1v1="ngModel"
          [(ngModel)]="catNiv1v1" required />
        <mat-autocomplete #autoo1="matAutocomplete" (optionSelected)="categoriesNiveau1Selected1($event)">
          <mat-option *ngFor="let c of categoriesNiveau1v1" [id]="'1' + c.categorie_Code" [value]="c.categorie_Text">
            {{ c.categorie_Text }}
          </mat-option>
        </mat-autocomplete>
      </div>
      <div class="car-field">
        <label class="car-label">Famille</label>
        <input class="car-input" [disabled]="disabled" id="1idCategoriesNiveau2" name="categoriesNiveau2"
          [matAutocomplete]="autoCategoriesNiveau21" [(ngModel)]="catNiv21"
          (input)="onCategoriesNiveau2Valuechange1($event)" placeholder="Famille" />
        <mat-autocomplete #autoCategoriesNiveau21="matAutocomplete"
          (optionSelected)="categoriesNiveau2Selected1($event)">
          <mat-option *ngFor="let option of categoriesNiveau2v1" [id]="'1' + option.categorie_Code"
            [value]="option.categorie_Text">{{ option.categorie_Text }}</mat-option>
        </mat-autocomplete>
      </div>
      <div class="car-field">
        <label class="car-label">Sous famille</label>
        <input class="car-input" [disabled]="disabled" id="1idCategoriesNiveau3" name="categoriesNiveau3"
          [matAutocomplete]="autoCategoriesNiveau31" [(ngModel)]="catNew"
          (input)="onCategoriesNiveau3Valuechange1($event)" placeholder="Sous famille" />
        <mat-autocomplete #autoCategoriesNiveau31="matAutocomplete"
          (optionSelected)="categoriesNiveau3Selected1($event)">
          <mat-option *ngFor="let option of categoriesNiveau31" [id]="'1' + option.categorie_Code"
            [value]="option.categorie_Text">{{ option.categorie_Text }}</mat-option>
        </mat-autocomplete>
      </div>
    </div>
    <div class="art-dialog__footer">
      <button type="button" class="car-btn car-btn--outline" (click)="closeDialog()">Annuler</button>
      <button type="button" class="car-btn car-btn--primary" (click)="save()">
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
          <polyline points="17 21 17 13 7 13 7 21" />
        </svg>
        Enregistrer
      </button>
    </div>
  </div>
</ng-template>